var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{attrs:{"icon":_vm.icon,"type":_vm.type,"custom-class":_vm.customClass}})}
var staticRenderFns = []

export { render, staticRenderFns }